// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Input } from "@components/Input";
import FloatButtons from "@components/FloatButtons";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { withStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import { ElementsCustom } from "@components/Elements";
// Assets
import { addSvg, deleteSvg, minimizeSvg } from "assets";
// Helpers
import { addArtifact } from "@helpers";
// Styles
import "views/Integrations/styles/styles.scss";

const Accordion = withStyles({
  root: {
    border: "none",
    boxShadow: "none",
    borderRadius: "5px",
    overflow: "hidden",
    backgroundColor: "#F4F4F4",
    marginBottom: 10,
    maxWidth: 1500,
    margin: "0 auto 10px auto"
  }
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    minHeight: 35,
    height: 45,
    "&$expanded": {
      minHeight: 35,
      height: 45
    },
    fontSize: 16,
    background: "#565671",
    padding: "0px 20px",
    color: "#FFF"
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    columnGap: "20px",
    alignItems: "center",
    margin: "8px 0",
    "&$expanded": {
      margin: "8px 0"
    }
  },
  expanded: {
    // minHeight: 'inherit'
  }
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    backgroundColor: "#F4F4F4",
    padding: "10px 30px",
    flexDirection: "column"
  }
})(MuiAccordionDetails);

class AccordionProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      set_tag: ""
    };
  }

  handleTags = (e, type, elementType, chipToDelete, i) => {
    var { set_tag } = this.state;
    var { config, iteration, updateElement } = this.props;
    var element_to_update;

    switch (elementType) {
      case "tags":
        element_to_update = config.zendesk.tags;
        break;
    }

    var tag = e.target.value;
    switch (type) {
      case "add":
        if (tag.match(/^[a-zA-Z0-9_\/]*$/)) {
          set_tag = tag;
          this.setState({ set_tag: set_tag });
        }
        break;
      case "delete":
        element_to_update.forEach((el) => {
          if (el === chipToDelete) {
            element_to_update.splice(i, 1);
          }
        });
        updateElement(config, "zendesk", "tags", iteration);
        break;
      case "enter":
        element_to_update.push(tag);
        updateElement(config, "zendesk", "tags", iteration);
        this.setState({ set_tag: "" });
        break;
    }
  };

  updateElementZendesk = (e, type) => {
    const { iteration, updateElement } = this.props;
    updateElement(e?.target?.value, "zendesk", type, iteration);
  };

  updateElementBot = (e, type) => {
    const { iteration, updateElement } = this.props;
    updateElement(e?.target?.value, "bot", type, iteration);
  };

  handleArtifacts = (e, i, artifact_type) => {
    const { config, updateElement, iteration } = this.props;
    var res = addArtifact(i, artifact_type, "sunco_admin", config);
    updateElement(res, "zendesk", "artifact", iteration);
  };

  deleteProject = (e) => {
    const { iteration, deleteElement } = this.props;
    e.stopPropagation();
    deleteElement(e, iteration);
  };

  render() {
    const {
      t,
      project_name,
      config,
      project_default,
      project_integration_in_use
    } = this.props;
    const { expanded, set_tag } = this.state;
    return (
      <Accordion square expanded={expanded}>
        <AccordionSummary
          onClick={() => this.setState({ expanded: !expanded })}
          expandIcon={
            !expanded ? <span>{addSvg()}</span> : <span>{minimizeSvg()}</span>
          }
        >
          <span>{project_name}</span>
          {project_default ? (
            <span className={"project_default"}>
              {t("channels:sunco.integrate.config.project_default")}
            </span>
          ) : !project_integration_in_use ? (
            <span
              onClick={(e) => this.deleteProject(e)}
              className={"project_delete"}
            >
              {deleteSvg()}
            </span>
          ) : (
            ""
          )}
        </AccordionSummary>
        <AccordionDetails>
          <span className={"title"}>{"Ticket"}</span>
          {/* HISTORICAL MESSAGES NUMBER */}
          <div>
            <ElementsCustom
              t={t}
              type={"sunco"}
              input_type={"input"}
              element_type={"historical_messages_number"}
              element={config.zendesk.historical_messages_number}
              updateElement={this.updateElementZendesk}
            />
            <Divider />
            {/* TAGS */}
            <ElementsCustom
              t={t}
              type={"sunco"}
              input_type={"input_with_tags"}
              element_type={"tags"}
              element={set_tag}
              elements={config.zendesk.tags}
              updateElement={this.handleTags}
            />
            <Divider />
            {/* TICKET FIELD CONVERSATION ID */}
            <ElementsCustom
              t={t}
              type={"sunco"}
              input_type={"input"}
              element_type={"ticket_field_conversation_id"}
              element={config.zendesk.ticket_field_conversation_id}
              updateElement={this.updateElementZendesk}
            />
            <Divider />
            <div className={"elements_custom"}>
              <div className={"elements_custom__info"}>
                <span className={"elements_custom__title"}>
                  {t("elements.custom.sunco.card.return_to_bot_message.title")}
                </span>
              </div>
              <div className={"elements_custom__copy"}>
                <Input
                  placeholder={t(
                    "elements.custom.sunco.card.return_to_bot_message.placeholder"
                  )}
                  value={config.zendesk.return_to_bot_message}
                  multiline
                  onChange={(e) =>
                    this.updateElementZendesk(e, "return_to_bot_message")
                  }
                />
                <FloatButtons
                  type={"sunco_bot_message"}
                  addArtifact={this.handleArtifacts}
                  buttons_toggle_artifacts={[
                    "whatsapp",
                    "link",
                    "button",
                    "carousel",
                    "bubble",
                    "for"
                  ]}
                />
              </div>
            </div>
          </div>
          {/* DISPLAY NAME */}
          <span className={"title"}>{"Bot"}</span>
          <div>
            <ElementsCustom
              t={t}
              type={"sunco"}
              input_type={"input"}
              element_type={"display_name"}
              element={config.bot?.display_name}
              updateElement={this.updateElementBot}
            />
            <Divider />
            {/* AVATAR URL */}
            <ElementsCustom
              t={t}
              type={"sunco"}
              input_type={"input"}
              element_type={"avatar_url"}
              element={config.bot?.avatar_url}
              updateElement={this.updateElementBot}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_app = connect(mapStateToProps)(AccordionProject);

export default withTranslation(["commons", "channels"])(
  withRouter(connect_app)
);
